import React from "react";
import DefaultLayout from "./DefaultLayout";
import classnames from "classnames";
import Loading from "../components/Loading";
import { connect } from "react-redux";

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"];

class Spotlight extends DefaultLayout {
  render() {
    const { metric, index } = this.props;
    const { data, isLoading } = this.state;
    return (
      <div
        id="outcome_survey_result"
        className={classnames(
          "col-xs-12",
          "col-lg-3",
          "mt-4",
          "mt-md-0",
          "p-0",
          "pl-0",
          "pl-lg-4"
        )}
      >
        <div className="shadow p-3">
          <div className="d-flex justify-content-center square-container align-items-center">
            {isLoading ? (
              <Loading />
            ) : (
              <div
                className="square-content d-flex justify-content-center align-items-center big-number"
                style={{
                  backgroundColor: "white",
                  color: COLORS[index % COLORS.length],
                }}
              >
                {data}
              </div>
            )}
          </div>
          <div
            className="body-container"
            style={{ color: "white", color: COLORS[index % COLORS.length] }}
          >
            <div className="title">{metric.title}</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    group_ids: state.filters.group_ids,
    resident_id: state.filters.resident_id,
    filter_by_resident: state.filters.filter_by_resident,
    group_categories: state.filters.group_categories,
    resident_statuses: state.filters.resident_statuses,
    start_date: state.filters.start_date,
    end_date: state.filters.end_date,
    isLoading: true,
    processing: true,
  };
}

export default connect(mapStateToProps)(Spotlight);
